import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, UsersIcon, ShieldCheckIcon, SparklesIcon, MessageCircleIcon, CheckCircleIcon } from 'lucide-react';
export function SymbisCoaching() {
  return <main className="bg-[#F8F9FA] min-h-screen" data-id="element-390">
      <section className="py-24 bg-[#D4A373] text-white relative overflow-hidden" data-id="element-391">
        <div className="absolute inset-0 bg-black/5" data-id="element-392" />
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-393">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="inline-block px-6 py-2 bg-white/20 backdrop-blur-md rounded-full mb-8 border border-white/30" data-id="element-394">
            <span className="text-sm font-bold uppercase tracking-[0.2em]" data-id="element-395">
              Certified Facilitation
            </span>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-6xl lg:text-8xl font-serif mb-8 leading-tight" data-id="element-396">
            SYMBIS <br data-id="element-397" />
            <span className="text-[#1B4332]" data-id="element-398">Relationship & Marriage</span>{' '}
            <br data-id="element-399" />
            Coaching
          </motion.h1>
          <p className="text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-400">
            Saving Your Marriage Before It Starts. Relationship restoration and
            strengthening for couples at every stage of their journey.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-401">
        <div className="container mx-auto px-4" data-id="element-402">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-403">
            <div data-id="element-404">
              <h2 className="text-4xl font-serif text-[#588157] mb-8" data-id="element-405">
                Rebuild Your Connection
              </h2>
              <p className="text-lg text-[#1A374D]/80 mb-8 leading-relaxed" data-id="element-406">
                As a Certified SYMBIS Facilitator and Couples Repair Specialist
                with 8 years of experience, we help couples navigate the
                complexities of partnership with evidence-based tools and
                compassionate guidance.
              </p>
              <div className="space-y-4" data-id="element-407">
                {['Pre-marital Preparation', 'Marriage Restoration & Repair', 'Communication Skill Building', 'Conflict Resolution Strategies', 'Deepening Emotional Intimacy', 'Rediscovering Shared Purpose'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-408">
                    <CheckCircleIcon className="text-[#D4A373]" size={20} data-id="element-409" />
                    <span className="font-medium text-[#1A374D]" data-id="element-410">{item}</span>
                  </div>)}
              </div>
            </div>
            <div className="relative" data-id="element-411">
              <div className="aspect-[4/3] rounded-3xl overflow-hidden shadow-2xl" data-id="element-412">
                <img src="https://images.unsplash.com/photo-1516589174184-c685266d430c?auto=format&fit=crop&q=80&w=1000" alt="Couple communicating" className="w-full h-full object-cover" data-id="element-413" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-8 rounded-2xl shadow-xl border border-[#D4A373]/20 max-w-xs" data-id="element-414">
                <HeartIcon className="text-[#D4A373] mb-4" size={32} data-id="element-415" />
                <p className="text-[#588157] font-serif italic text-lg" data-id="element-416">
                  "Restoring the heart of your home."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-id="element-417">
        <div className="container mx-auto px-4 text-center" data-id="element-418">
          <h2 className="text-3xl font-serif text-[#588157] mb-12" data-id="element-419">
            The SYMBIS Advantage
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-420">
            <div className="p-8 rounded-2xl bg-[#F8F9FA]" data-id="element-421">
              <MessageCircleIcon className="mx-auto text-[#D4A373] mb-6" size={40} data-id="element-422" />
              <h3 className="text-xl font-bold text-[#588157] mb-4" data-id="element-423">
                Deep Insights
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-424">
                Comprehensive assessments that reveal the underlying dynamics of
                your relationship.
              </p>
            </div>
            <div className="p-8 rounded-2xl bg-[#F8F9FA]" data-id="element-425">
              <UsersIcon className="mx-auto text-[#D4A373] mb-6" size={40} data-id="element-426" />
              <h3 className="text-xl font-bold text-[#588157] mb-4" data-id="element-427">
                Expert Facilitation
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-428">
                8 years of specialized experience in marriage repair and
                relationship restoration.
              </p>
            </div>
            <div className="p-8 rounded-2xl bg-[#F8F9FA]" data-id="element-429">
              <SparklesIcon className="mx-auto text-[#D4A373] mb-6" size={40} data-id="element-430" />
              <h3 className="text-xl font-bold text-[#588157] mb-4" data-id="element-431">
                Lasting Change
              </h3>
              <p className="text-[#1A374D]/70" data-id="element-432">
                Practical tools and strategies designed to sustain a healthy,
                purpose-driven marriage.
              </p>
            </div>
          </div>
          <button onClick={() => window.location.hash = '#contact-us'} className="mt-16 px-12 py-4 bg-[#D4A373] text-white font-bold rounded-full hover:bg-[#966d09] transition-all shadow-lg text-lg" data-id="element-433">
            Start Your Relationship Assessment
          </button>
        </div>
      </section>
    </main>;
}